import { render } from "./AssignGpsDevice.vue?vue&type=template&id=9a073c6e&scoped=true"
import script from "./AssignGpsDevice.vue?vue&type=script&lang=js"
export * from "./AssignGpsDevice.vue?vue&type=script&lang=js"

import "./AssignGpsDevice.vue?vue&type=style&index=0&id=9a073c6e&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a073c6e"]])

export default __exports__